angular.module('harriApp')

  .directive('monthPicker', ["$timeout", function($timeout){
    return {
      restrict: 'E',
      scope: {
        hModel: '=',
        ngModel: '='
      },
      template: function(element, attr) {
        if (checkInputSupported('month')) {
          return '<input type="month" class="form-control" />';
        }
        else {
          var months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
          var currentYear = new Date().getFullYear();

          var monthElm = $('<select class="monthSelect dateSelect form-control"><option></option></select>');

          for (var i in months) {
            monthElm.append("<option value='" + i + "'>" + months[i] + "</option>");
          }

          var yearElm = $('<select class="yearSelect dateSelect form-control"><option></option></select>');

          for (var i=0; i < 50; i++) {
            yearElm.append("<option>" + (currentYear - i) + "</option>");
          }

          var wrapperElm = $('<div></div>');
          wrapperElm.append(monthElm);
          wrapperElm.append(yearElm);

          return '<div>' + wrapperElm.html() + '</div>';
        }
      },
      link: function(scope, element, attrs) {
        if (checkInputSupported('month')) {
          element.find('[type="month"]').change(function(){
            if (element.find('[type="month"]').val()) {
              scope.hModel = new Date(element.find('[type="month"]').val()).toUTCString();
            }
            else {
              scope.hModel = '';
            }

            scope.$apply();
            scope.$parent.form.validate();

          })
        }
        else {
          element.find("select").change(function(){
            var month = element.find(".monthSelect").val();
            var year = element.find(".yearSelect").val();

            if (month && year) {
              scope.hModel = new Date(year, month).toUTCString();
            }
            else {
              scope.hModel = '';
            }

            scope.$apply();
            scope.$parent.form.validate();
          });
        }

        //watch monthPicker model to update UI when the model is updated by the resume autofill
        scope.$watch('hModel',function(newVal, old){
            if (newVal){
                var date = new Date(newVal);
                var year = date.getFullYear()
                //month in mm format, leading 0 is for months from 1 to 9, that's why we slice to the las two charcters on case the month is 10,11, or 12
                var month = ('0' + (date.getMonth()+1)).slice(-2) ;
                element.find('[type="month"]').val(year +'-'+ month );
            }

        });

      }
    }
  }])

    .directive('monthDatePicker', ['$parse', '$timeout', function($parse, $timeout) {
        return {
            restrict:'E',
            templateUrl: '../modules/forms/components/monthDatePicker/monthDatePicker.html',
            scope:{
                ngModel:'=',
                name:'@',
                ngRequired:'=',
                hDisabled:'=',
                updateEndDate:'=',
                startDate:'=',
                validateEndDate:'=',
                containerPrefix:'@',
                futureDate : '=?'
            },
            link: function(scope, element, attrs) {

                if(!scope.ngRequired) {
                  scope.ngRequired = false;
                }

                var months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

                //months object
                scope.months = [];
                for(var k in months) {
                    scope.months.push({value: k, label:months[k]});
                }

                scope.years = [];
                var yearsRange = 50;
                var yearsRangeInFuture = 0;

                if( scope.futureDate ){
                  if( angular.isNumber( scope.futureDate ) ){
                    yearsRangeInFuture = scope.futureDate;
                  }else{
                    yearsRangeInFuture = 10;
                  }
                  yearsRange = 0;
                }

                var today = new Date();
                var currentYear = today.getFullYear();

                for(var i = currentYear + yearsRangeInFuture ; i >= currentYear - yearsRange ; i--) {
                    scope.years.push({label:i, value:i});
                }

                if (scope.futureDate) {
                    scope.years.reverse();
                }



                var oldState = undefined;

                scope.$watch(function() {
                    return scope.ngModel;
                }, function(n) {
                    if(n) {
                        var selectedDate = new Date(n);

                        if(oldState == selectedDate) {
                            return;
                        }

                        var selected_year = selectedDate.getFullYear();
                        scope.selected_year = {label:selected_year, value:selected_year};

                        var selected_month = selectedDate.getMonth();
                        scope.selected_month = {label: months[selected_month], value:selected_month};


                        oldState = selectedDate;
                    } else {
                        scope.selected_year = undefined;
                        scope.selected_month = undefined;
                    }
                });


                scope.$watchGroup(['selected_month' , 'selected_year'], function(n) {

                    if(n[0] && n[1]) {

                        var selectedDate = new Date((parseInt(n[0].value) + 1) + "/1/" + n[1].value + " 12:00:00");

                        if (selectedDate == oldState) {
                            return;
                        }

                        element.find('input[name='+scope.name+']').change();

                        scope.ngModel = selectedDate.toUTCString();

                        if((scope.updateEndDate === true || scope.updateEndDate == undefined) &&  attrs.endDate) {
                            var endDateValue = scope.$parent.$eval(attrs.endDate);
                            if(!endDateValue) {
                                var endDate = new Date(scope.ngModel);
                                endDate.setFullYear( endDate.getFullYear() + 1 );
                                scope.$parent.$eval(attrs.endDate + ' = "' + endDate.toUTCString() + '"')
                            }
                        }

                        validate();

                        oldState = selectedDate;
                    }
                });

                function validate() {
                }


            }
        }
    }])

    .directive('validateStartDate', function() {
        return {
            require:'ngModel',
            scope:{
                //start date
                validateStartDate:'=',
                ngModel:'=',
                validateEndDate:'=',
                ngRequired:'='
            },
            link: function(scope, element, attrs, ngModel) {

                //if(scope.validateEndDate == "true" || scope.validateEndDate == true) {
                    scope.$watch(function () {

                        if (scope.ngModel != undefined && scope.validateStartDate != undefined && scope.validateEndDate) {

                            if ((new Date(scope.ngModel)) > (new Date(scope.validateStartDate))) {
                                return true;
                            } else {
                                return false;
                            }

                        } else {
                            return true;
                        }

                    }, function (n) {
                        ngModel.$setValidity("mindate", n);
                    })
                //}
            }
        }
    })

    .directive('validateGreaterThan', function() {
    return {
        require:'ngModel',
        link: function(scope, element, attrs, ngModel) {


            scope.$watch(function () {

                var validateGreaterThan = scope.$eval(attrs.validateGreaterThan);
                var ngModel = scope.$eval(attrs.ngModel);
                if(ngModel && validateGreaterThan) {
                    if(scope.isDate && (scope.isDate == "true" || scope.isDate == true)) {
                        validateGreaterThan = new Date(validateGreaterThan);
                        console.log('@3', ngModel);
                        ngModel = new Date(ngModel);
                    }

                    return ngModel >= validateGreaterThan;
                } else {
                    return true;
                }

            }, function (n) {
                ngModel.$setValidity("greater", n);
            });

        }
    }
})